// removed by extract-text-webpack-plugin
module.exports = {"Contact":"Contact__Contact__1Ywkr","row":"Contact__row__1Kp7-","HSpan":"Contact__HSpan__13FTS","Img":"Contact__Img__1ExYr","Lead":"Contact__Lead__14i-M","Columns":"Contact__Columns__Bvzow","Button":"Contact__Button__3W9v8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/Contact.css
// module id = 148
// module chunks = 0